import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import PageErrorImage from "@/assets/svg/pageError.svg?react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/auth/useAuth";

interface ErrorBoundaryPageProps {
  errorMessage: string;
  onReset: () => void;
}

const ErrorBoundaryPage = ({
  errorMessage,
  onReset
}: ErrorBoundaryPageProps) => {
  const location = useLocation();
  const { logout, isAuthenticating, isAuthenticated } = useAuth();

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    // Redirect to login only when not authenticating and user is not authenticated
    if (
      !isAuthenticating &&
      !isAuthenticated &&
      location.pathname !== "/login"
    ) {
      onReset();
    }
  }, [
    onReset,
    location.pathname,
    location.search,
    isAuthenticated,
    isAuthenticating
  ]);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-teal-50">
      <div className="shrink-0">
        <PageErrorImage className="flex-1" />
      </div>
      <p className="text-2xl font-bold text-center text-txtHeading">
        Oops! Something didn't load correctly.
      </p>
      <p className="text-center text-body-16-rg text-neutral-600">
        {errorMessage}
      </p>
      <Button
        className="px-8 py-3 text-base font-semibold my-9 rounded-xl"
        variant="outline"
        onClick={handleLogout}
      >
        Back to Login Page
      </Button>
    </div>
  );
};

export default ErrorBoundaryPage;
